import React from 'react';
import './Spinner.scss';

const Load = () => {
  // Cria um array de 6 itens para simular os cards
  const skeletonItems = Array.from({ length: 6 });

  return (
    <div className="skeleton-wrapper wrapper">
      {/* Simula o Header/Capa */}
      <div className="skeleton-header"></div>
      
      {/* Simula a Barra de Categorias */}
      <div className="skeleton-nav">
        <div className="skeleton-pill"></div>
        <div className="skeleton-pill"></div>
        <div className="skeleton-pill"></div>
        <div className="skeleton-pill"></div>
      </div>

      {/* Simula o Grid de Produtos */}
      <div className="skeleton-grid">
        {skeletonItems.map((_, index) => (
          <div key={index} className="skeleton-card">
            <div className="skeleton-text-group">
              <div className="skeleton-title"></div>
              <div className="skeleton-desc"></div>
              <div className="skeleton-price"></div>
            </div>
            <div className="skeleton-image"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Load };